import { CompactButton } from '@/components/buttons/compact';
import { StandardButton } from '@/components/buttons/standard';
import { CustomContentSection } from '@/components/custom-content-section';
import { PrimaryLayout } from '@/layouts/primary';
import { Text } from '@mantine/core';
import { IconMailOpened, IconX } from '@tabler/icons-react';
import { useNavigate } from '@tanstack/react-router';
import { useCallback, useMemo } from 'react';
import {
	ContentSectionLocation,
	ContentSectionPlacement,
} from '../../../../backend/src/types.generated';

export const CancelAutoRenewPage = () => {
	const navigate = useNavigate();
	const backToHome = useCallback(() => navigate({ to: '/home' }), [navigate]);
	const closeButton = useMemo(
		() => (
			<CompactButton leftSection={<IconX />} onClick={backToHome}>
				Close
			</CompactButton>
		),
		[backToHome]
	);
	const cancelAutoRenewButton = useMemo(
		() => <StandardButton variant="danger">Cancel Auto Renew</StandardButton>,
		[]
	);

	return (
		<PrimaryLayout
			header={{ title: 'Cancel Auto Renew', children: closeButton }}
			footer={{ children: cancelAutoRenewButton }}
		>
			<CustomContentSection
				location={ContentSectionLocation.CancelAutoRenew}
				placement={ContentSectionPlacement.Top}
			/>
			<IconMailOpened size={32} />
			<Text ta="center" size="lg" fw={900}>
				Rewards page
			</Text>
			<CustomContentSection
				location={ContentSectionLocation.CancelAutoRenew}
				placement={ContentSectionPlacement.Middle}
			/>
			<CustomContentSection
				location={ContentSectionLocation.CancelAutoRenew}
				placement={ContentSectionPlacement.Bottom}
			/>
		</PrimaryLayout>
	);
};
